export default class Invoice {
    invoiceId!: string;
    projectId!: string;
    invoiceNumber!: string;
    invoiceDate!: Date;
    invoiceAmount!: number;
    invoiceType!: number;
    accountCode?: string;
    otherDetails?: string;
}